import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import RotaProtegida from './components/RotaProtegida';
import Login from './pages/Login';
import RegistroEscritorio from './pages/RegistroEscritorio';
import Inicio from './pages/Inicio';
import Configuracoes from './pages/Configuracoes';
import Equipe from './pages/Equipe';
import Admin from './pages/Admin';
import Agenda from './pages/Agenda';
import Clientes from './pages/Clientes';
import Contratos from './pages/Contratos';
import Pagamentos from './pages/pagamentos';
import Processos from './pages/Processos';
import PrazosProcesso from './pages/PrazosProcesso';
import Assinatura from './pages/Assinatura';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Públicas */}
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<RegistroEscritorio />} />

          {/* Escritório (exigem login) */}
          <Route path="/inicio" element={<RotaProtegida><Inicio /></RotaProtegida>} />
          <Route path="/agenda" element={<RotaProtegida><Agenda /></RotaProtegida>} />
          <Route path="/clientes" element={<RotaProtegida><Clientes /></RotaProtegida>} />
          <Route path="/contratos" element={<RotaProtegida><Contratos /></RotaProtegida>} />
          <Route path="/pagamentos" element={<RotaProtegida><Pagamentos /></RotaProtegida>} />
          <Route path="/processos" element={<RotaProtegida><Processos /></RotaProtegida>} />
          <Route path="/prazos" element={<RotaProtegida><PrazosProcesso /></RotaProtegida>} />
          <Route path="/configuracoes" element={<RotaProtegida><Configuracoes /></RotaProtegida>} />
          <Route path="/assinatura" element={<RotaProtegida><Assinatura /></RotaProtegida>} />

          {/* Somente proprietário */}
          <Route path="/equipe" element={<RotaProtegida somenteProprietario><Equipe /></RotaProtegida>} />

          {/* Somente administrador do sistema */}
          <Route path="/admin" element={<RotaProtegida somenteAdmin><Admin /></RotaProtegida>} />

          <Route path="*" element={<Navigate to="/inicio" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
